/**
 * Module: Gallery Slider / Swiper & GLightbox
 * Description: Inizializza uno slider Swiper con supporto a lightbox (immagini e video).
 *
 */

export function initGallerySlider() {
  // Controlla se Swiper e GLightbox sono definiti
  if (typeof Swiper === "undefined" && typeof GLightbox === "undefined") {
    console.warn(" Swiper e GLightbox non sono disponibili");
    return;
  }

  const galleryWrappers = document.querySelectorAll(".gallery-swiper-lightbox");

  if (galleryWrappers.length === 0) {
    console.warn(
      "Swiper e GLightbox sono disponibili ma nessuna galleria media è stata trovata in questa pagina"
    );
    return;
  }

  galleryWrappers.forEach((wrapper, index) => {
    const swiperContainer = wrapper.querySelector(
      ".swiper.swiper-gallery-media"
    );
    const postId = wrapper.dataset.postid;
    console.log("Post ID -> ", postId, wrapper);

    if (!swiperContainer) {
      console.error("❌ Nessun elemento .swiper trovato nel wrapper:", wrapper);
      return;
    }

    const slides = swiperContainer.querySelectorAll(".swiper-slide");
    const enableLoop = slides.length > 1;

    console.log(`Abilitato gallery loop: ${enableLoop}`);

    console.log(
      "Inizializzazione galleria Swiper e Lightbox 👍",
      "\n",
      `Contenitore Swiper → ".swiper.swiper-gallery-media"`,
      "\n",
      `Swiper gallery → trovata "${index + 1}"`
    );

    new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: enableLoop,
      speed: 600,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: `.swiper-button-next-${postId}`,
        prevEl: `.swiper-button-prev-${postId}`,
      },
      pagination: {
        el: `.swiper-pagination-${postId}`,
        clickable: true,
      },
    });

    // Assicura un ID valido per il wrapper (necessario per il selettore lightbox)
    if (!wrapper.id) {
      wrapper.id = `gallery-swiper-lightbox-${index}`;
      console.warn(`Wrapper senza ID: assegnato ID generico "${wrapper.id}"`);
    }

    GLightbox({
      selector: `#${wrapper.id} .gallery-item`,
    });
  });
}
